import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// TODO:: Move it to a library for re-usability.
export function CustomEstimatedCostValidator(
  compareControl: AbstractControl
): ValidatorFn {
  return function (control: AbstractControl): ValidationErrors | null {
    if (!compareControl?.value && !control?.value) {
      return { required: true };
    }
    return null;
  };
}
